module.exports = __webpack_public_path__ + "img/vote-3@2x.1b3ae80c.png";